import React, { Component } from 'react';
import Footer from "../../components/Footer";
import Utils from '../../utils/utils';
import { message } from "antd";
import {withRouter} from "react-router-dom";
import anime from 'animejs';
import Loader from '../../components/loader';
import './index.less';
import close from "../../assets/img/close.png";
import news from "../../assets/img/news_detail.jpg";
import Axios from "../../axios";
import { BaseUrl } from './../../utils/globalConst';
import Fade from 'react-reveal/Fade';
import leftIcon from '../../assets/img/icon_left.png';
import rightIcon from '../../assets/img/icon_right.png';
// import {Link} from 'react-router-dom'
const rdom = require('react-dom');



class NewsDetail extends Component {
    state = {
        newBg: '#2b2b2b',
        newsImg: news,
        _pro: '',
        isLoading: true,
        isAnimate: true,
        offsetheight: 0,
        windowHeight: document.body.clientHeight,
        bannerWidth: 0,
        fullPage: 0,    //当前在第几页
        fullPage1: 0,    //当前在第几页
        imgPage: 0,
        txtPage: 0,
        fullPageNum: false,
        newsList: [],
        scrollTop: 0,
        isMove: true,
        isSend: true,
        imgList: [],
        txtList: [],
        nextItem: []
    }
    componentWillMount() {
        // let href=window.location.href;
        // let id = href.split('?')[1];

        let id = this.props.match.params.id;
        console.log(id)
        let params = { id: id }
        this.detailsRequest(params);
        let proItems = sessionStorage.getItem('newsList');
        proItems = JSON.parse(proItems);
        this.setState({
            proItems
        })
        proItems.map((item, index) => {
            if (item.id === id) {
                if (index < (proItems.length - 1)) {
                    let nextItem = proItems[index + 1];
                    this.setState({
                        nextItem
                    })
                } else {
                    let nextItem = proItems[0];
                    this.setState({
                        nextItem
                    })
                }
            }
        })

    }
    //鼠标悬停
    handleOver = () => {
        var textWrapper = document.querySelector('.enter-txt');
        textWrapper.innerHTML = textWrapper.textContent.replace(/([^\x00-\x80]|\w)/g, "<span class='letter'>$&</span>");
        anime.timeline({ loop: 1 })
            .add({
                targets: '.letter',
                translateY: [0, -14, 0],
                easing: "easeOutExpo",
                duration: 300,
                delay: function (el, i) {
                    return 100 + 40 * i;
                }
            })
    }
    animation = () => {
        var canvas = document.getElementById('myCanvas');
        var img = document.getElementById('imgs');
        let imgColor = Utils.getImageColor(canvas, img);
        let bgColor = imgColor[2];
        this.setState({
            newBg: bgColor,
        })
        anime.timeline({ loop: 1 })
            .add({
                targets: '.info_title',
                translateX: [-300, 0],
                opacity: [0, 1],
                easing: "linear",
                duration: 2000
            })
            .add({
                targets: '.info_exp',
                translateX: [300, 0],
                opacity: [0, 1],
                easing: "linear",
                duration: 1000
            })
            .add({

            })
    }
    //详情请求
    detailsRequest = (params) => {
        let _this = this;
        this.setState({
            isLoading: true,
        })
        Axios.get({
            block: '/api/post',
            url: '/detail',
            params: params,
        }).then((data) => {
            if (data.code === 0) {
                let proItems = [];
                let items = data.data;
                let item = items.post;
                let content = JSON.parse(item.content);
                let reqNewsList = content;
                let imgList = reqNewsList.filter(x => {
                    return x.img;
                })
                let txtList = reqNewsList.filter(x => {
                    return x.txt;
                })
                if (!imgList.length) {
                    imgList[0] = {
                        img: '/uploads/newsList/1908/file_hKclCglEHW9wYrOPD6G.png'
                    }
                }
                if (!txtList.length) {
                    txtList[0] = {
                        txt: ''
                    }
                }
                if(!reqNewsList.length){
                    reqNewsList = [{img:'/uploads/newsList/1908/file_hKclCglEHW9wYrOPD6G.png',txt:''},]
                }

                reqNewsList[0].img = imgList[0].img;
                reqNewsList[0].txt = txtList[0].txt;

                let time1 = item.time.substring(0,11).split('-').join('/');
                let _time = new Date(time1);
                let dateArray = Utils.getNowTime(_time);//获取
                let time = dateArray[0] + ' ' + dateArray[1] + dateArray[2];
                item.time = time;
                item.content = content;
                proItems.push(item);
                let _pro = proItems[0];
                this.setState({
                    _pro,
                    imgList,
                    txtList,
                    newsList: reqNewsList
                })
            } else {
                message.error(data.msg)
            }
            setTimeout(function () {
                _this.setState({
                    isLoading: false
                })
            }, 1000)
        }).catch((error) => {
            console.log(error);
        })
    }
    pageInfo(index) {
        this.setState({
            fullPage: index,
        })

    }
    componentDidMount() {
    }
    //改变轮播图
    changeFullPage(index) {
        let { fullPage, newsList, imgPage, txtPage, fullPage1 } = this.state;
        let pageArr = [];
        let txtArr = [];
        newsList.map((item, num) => {
            if (item.img) {
                if (num != 0) {
                    pageArr.push(pageArr[num - 1] + 1);
                } else {
                    pageArr.push(num);
                }
            } else {
                pageArr.push(pageArr[pageArr.length - 1]);
            }
            if (item.txt) {
                if (num != 0) {
                    txtArr.push(pageArr[num - 1] + 1)
                }
                else {
                    txtArr.push(num);
                }
            } else {
                txtArr.push(txtArr[txtArr.length - 1]);
            }
        })
        imgPage = imgPage + index;
        txtPage = txtPage + index;
        if (imgPage < 0) {
            imgPage = 0;
        } else if (imgPage > newsList.length - 1) {
            imgPage = newsList.length - 1;
        }
        if (txtPage < 0) {
            txtPage = 0;
        } else if (txtPage > newsList.length - 1) {
            txtPage = newsList.length - 1;
        }
        fullPage1 = txtArr[txtPage];
        fullPage = pageArr[imgPage];
        this.setState({
            imgPage,
            txtPage,
            fullPage,
            fullPage1
        })
    }
    //获取下一详情
    nextClick = (e, id) => {
        const { proItems } = this.state;
        this.setState({
            imgPage:0,
            txtPage:0,
            fullPage:0,
            fullPage1:0
        })
        proItems.map((item, index) => {
            if (item.id == id) {
                if (index < (proItems.length - 1)) {
                    let _pro = proItems[index + 1];
                    this.detailsRequest({ id: _pro.id })
                } else {
                    let _pro = proItems[0];
                    this.detailsRequest({ id: _pro.id })
                }
                window.scrollTo(0, 0);
            }
        })
    }
    render() {
        const { newBg, _pro, isLoading, newsList, windowHeight, imgList, txtList } = this.state;
        const basicStyle = {
            height: '80vh',
            width: '78vw',
            border: '1vw solid #ffd703',
        }
        return (
            isLoading ? <Loader cTitle="新闻" eTitle="NEWS" />
                : <div>
                    <div className="news-detail" id='newsDetail' style={{ paddingTop: windowHeight + 'px' }}>
                        <div className='custom-class' id='customClass' style={{ height: windowHeight + 'px' }}>
                            <header className="header-title">
                                <h1 className="white">
                                    <a href="javascript:void(0)" onClick={()=>{this.props.history.push(`/news`)}}>
                                        <p className="back-txt">close</p>
                                        {/*<img src={close} className="back-icon" width="20" alt="close" />*/}
                                    </a>
                                </h1>
                            </header>
                            <div className="detail-info">
                                <div className="info-exp first-tip">
                                    <div className="left "><h4 className="info_title">
                                        <Fade cascade duration={3000}>
                                            {_pro.title}
                                        </Fade>
                                    </h4></div>
                                    <div className="right info_exp">
                                        <h6>
                                            <Fade cascade right delay={1000}>
                                                {_pro.time}
                                            </Fade>
                                        </h6>
                                        <h6>
                                            <Fade cascade right delay={1000}>
                                                {_pro.description}
                                            </Fade>
                                        </h6>
                                    </div>
                                </div>
                            </div>info_exp
                        </div>
                        <div style={{ background: '#fff', position: 'relative', zIndex: 4 }}>
                            <div className="main-image" id='main-image' style={{ background: newBg, zIndex: 3 }}>
                                <div className='img-wrap-con'>
                                    <img className='img-left-arrow' onClick={() => this.changeFullPage(-1)} src={leftIcon} alt="" />
                                    {/* onWheel={(e) => this.scroll(e)} */}
                                    <div style={basicStyle} className="section" id='section'>
                                        {
                                            <div className="container" id='container' style={{ 'transform': 'translate3d(' + -this.state.fullPage * 76 + 'vw,0px, 0px)', width: 76 * newsList.length + 'vw' }}>
                                                {imgList.map((item, index) => {
                                                    return (<div className='middle-pic' key={index} >
                                                        <div className="pic-exp" style={{ 'backgroundImage': `url(${BaseUrl + item.img})` }}>
                                                        </div>
                                                    </div>)
                                                })}
                                            </div>
                                        }
                                        <div className="container1">
                                            {
                                                txtList.length ? txtList.map((item, index) => {
                                                    return (
                                                        <p key={index} className={this.state.fullPage1 == index ? 'animation' : ''}>
                                                            {item.txt}
                                                        </p>)
                                                }) : ''
                                            }
                                        </div>
                                    </div>
                                    <img src={rightIcon} onClick={() => this.changeFullPage(1)} alt="" className='img-right-arrow' />
                                </div>
                            </div>
                            <div className="detail-switch">
                                <div className="info-exp send-tip">
                                    <div className="left"><h4 className="switch-title">NEWS</h4></div>
                                    <div className="right switch-info">
                                        <h5>{_pro.title}</h5>
                                        <p>
                                            {_pro.description}
                                        </p>
                                        <a className="next" onMouseOver={this.handleOver} onClick={(e) => this.nextClick(e, _pro.id)}>
                                            {/*<img src={next}/>*/}
                                            <div className='img-yellow'></div>
                                            <div className="next-img"></div>
                                            <div className='enter-txt-wrap'><div className="enter-txt">enter</div></div>
                                        </a>
                                    </div>
                                </div>
                                <Footer />
                            </div>

                        </div>

                    </div  >
                    {/*<Nav/>*/}
                </div>

        )
    }
}
export default withRouter(NewsDetail);
